import React, { useState, useEffect } from 'react';
import {
    Box,
    Center,
    Heading,
    HStack,
    Image,
    Link,
    Text,
    View
} from "native-base";
import Subscribe from './Subscribe';

const image = require('../../assets/icon.png');
const year = new Date().getFullYear();

const Footer = () => {
    return (
        <Center h="13%" bg="white" pt="15" pb="15">
            {/* <Subscribe></Subscribe> */}
            <HStack alignItems="center">
                <Image
                    source={image}
                    size="2xs"
                    mb="2"
                />
            </HStack>
            <HStack>
                <Link _text={{ fontSize: 10 }} href="/">Home</Link>
                <Text mt="-1" ml="1" mr="1" _text={{ fontSize: 10 }}>•</Text>
                <Link _text={{ fontSize: 10 }} href="/terms-of-service">Terms of Service</Link>
                <Text mt="-1" ml="1" mr="1" _text={{ fontSize: 10 }}>•</Text>
                <Link _text={{ fontSize: 10 }} href="/privacy-policy">Privacy Policy</Link>
            </HStack>
            <View p="1">
                <Text style={{ fontSize: 10 }}>© {year} Invitemenot.com</Text>
            </View>
        </Center>
    );
}

export default Footer;